module.exports = __webpack_public_path__ + "img/scienjoy.2ce1fafa.png";